"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var fieldProcessors_1 = require("utils/fieldProcessors");
var Separator_1 = __importDefault(require("./styles/Separator"));
var PREFIX = 'DealType';
var classes = {
    hudledDeal: "".concat(PREFIX, "-hudledDeal"),
    dealValue: "".concat(PREFIX, "-dealValue"),
    valueLightGrey: "".concat(PREFIX, "-valueLightGrey"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.hudledDeal)] = __assign(__assign({}, theme.typography.h2), { paddingBottom: 3 }),
        _b[".".concat(classes.dealValue)] = {
            paddingTop: theme.spacing(1),
        },
        _b[".".concat(classes.valueLightGrey)] = {
            color: theme.palette.grey[600],
            fontWeight: theme.typography.fontWeightLight,
            fontSize: theme.typography.fontSize,
        },
        _b);
});
var DealType = function (_a) {
    var deal = _a.deal, _b = _a.hideValue, hideValue = _b === void 0 ? false : _b;
    var innerContent;
    var pricingLicense = '';
    if (deal.isPricingPerLicense)
        pricingLicense = 'licence / yr';
    switch ("".concat(deal.type, "-").concat(deal.durationType)) {
        case 'discount-LTV':
            innerContent = ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [(0, fieldProcessors_1.percentage)(deal.discountAmount || 0), " discount"] }), " for life on every dollar you spend."] })));
            break;
        case 'discount-timeLimited':
            innerContent = ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [deal.discountAmount ? (0, fieldProcessors_1.percentage)(deal.discountAmount) : (0, fieldProcessors_1.percentage)(0), " off"] }), " for the first", ' ', deal.discountDurationInMonths && (deal.discountDurationInMonths % 12 === 0
                        ? (0, jsx_runtime_1.jsxs)("strong", { children: ["year", deal.discountDurationInMonths / 12 > 1 && 's'] })
                        : (0, jsx_runtime_1.jsxs)("strong", { children: ["month", deal.discountDurationInMonths > 1 && 's'] })), ' ', "using this tool."] })));
            break;
        case 'rebate-LTV':
            innerContent = ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [(0, fieldProcessors_1.percentage)(deal.discountAmount || 0), " rebate"] }), " for life on every dollar you spend."] })));
            break;
        case 'rebate-timeLimited':
            innerContent = ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [" ", deal.discountAmount ? (0, fieldProcessors_1.percentage)(deal.discountAmount) : (0, fieldProcessors_1.percentage)(0), " rebate"] }), " for the first", ' ', deal.discountDurationInMonths && (deal.discountDurationInMonths % 12 === 0
                        ? (0, jsx_runtime_1.jsxs)("strong", { children: ["year", deal.discountDurationInMonths / 12 > 1 && 's'] })
                        : (0, jsx_runtime_1.jsxs)("strong", { children: ["month", deal.discountDurationInMonths > 1 && 's'] })), ' ', "using this tool."] })));
            break;
        case 'rebate-oneOff':
            pricingLicense = '';
            // ToDo: handle {deal.currency === 'AUD' ? 'A' : 'US'} in the money component by relying on the IntlFormatter
            innerContent = ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [deal.currency === 'AUD' ? 'A' : 'US', (0, jsx_runtime_1.jsx)(Money_1.default, { amount: deal.oneOffRebatePay || 0, currency: deal.currency })] }), ' ', "one off when you sign up for this tool."] })));
            break;
        case 'credits-LTV':
            innerContent = ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [deal.currency === 'AUD' ? 'A' : 'US', (0, jsx_runtime_1.jsx)(Money_1.default, { amount: deal.creditsAmount || 0, currency: deal.currency })] }), ' ', "in free to use this tool."] })));
            break;
        case 'credits-timeLimited':
            innerContent = ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [deal.currency === 'AUD' ? 'A' : 'US', (0, jsx_runtime_1.jsx)(Money_1.default, { amount: deal.creditsAmount || 0, currency: deal.currency })] }), ' ', "in free processing available for", ' ', deal.discountDurationInMonths
                        && (deal.discountDurationInMonths % 12 === 0
                            ? (0, jsx_runtime_1.jsx)("strong", { children: deal.discountDurationInMonths / 12 === 1 ? 'one year' : "".concat(deal.discountDurationInMonths / 12, " years") })
                            : (0, jsx_runtime_1.jsx)("strong", { children: deal.discountDurationInMonths === 1 ? 'one month' : "".concat(deal.discountDurationInMonths, " months") })), "."] })));
            break;
        default:
            // delete this when credits having no durationType is resolved
            if (deal.type === 'credits') {
                innerContent = ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [deal.currency === 'AUD' ? 'A' : 'US', (0, jsx_runtime_1.jsx)(Money_1.default, { amount: deal.creditsAmount, currency: deal.currency })] }), ' ', "in free ", (0, jsx_runtime_1.jsx)("strong", { children: "credits" }), " to use this tool."] })));
            }
            else {
                innerContent = (0, jsx_runtime_1.jsx)(Root, {});
            }
            break;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Separator_1.default, {}), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, sx: { pb: 0.25, lineHeight: '1.4rem' } }, { children: (0, jsx_runtime_1.jsxs)("strong", { children: [deal.isExclusive && 'Exclusive ', " Hudled Deal"] }) })), innerContent, !hideValue && ((0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1, sx: { pt: 1 } }, { children: [deal.type === 'credits' ? 'Value' : 'Save', ' ', deal.currency === 'AUD' ? 'A' : 'US', (0, jsx_runtime_1.jsx)(Money_1.default, { amount: deal.dealValueEstimate, currency: deal.currency }), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: "caption" }, { children: [" ", pricingLicense] }))] })))] }));
};
exports.default = DealType;
